export default __webpack_public_path__ + "static/p5-9a569372493263b8196a6dd79ba07db9.png";